import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_vxe_radio_group = _resolveComponent("vxe-radio-group");
  return _openBlock(), _createBlock(_component_vxe_radio_group, _mergeProps(_ctx.$attrs, {
    "model-value": $props.value,
    disabled: _ctx.disabled,
    readonly: _ctx.readonly,
    size: _ctx.size,
    options: $props.options,
    "option-props": $props.optionProps,
    strict: $props.strict,
    onChange: $setup.handleChanged
  }), _createSlots({
    _: 2
  }, [_renderList(Object.keys(_ctx.$slots), key => {
    return {
      name: key,
      fn: _withCtx(scope => [_renderSlot(_ctx.$slots, key, _normalizeProps(_guardReactiveProps(scope)))])
    };
  })]), 1040, ["model-value", "disabled", "readonly", "size", "options", "option-props", "strict", "onChange"]);
}